import { AddressService } from '@omni/services/address/address.service';

import { ChangeDetectionStrategy, Component, ViewChild, OnInit, ChangeDetectorRef, Input } from '@angular/core';
// import { MapsAPILoader} from '@agm/core'; // to do the predictive analysis
import { DeviceService } from '../../services/device/device.service';
import { IonSearchbar } from '@ionic/angular';
import { UIService } from '../../services/ui/ui.service';
import { ActivityService } from '../../services/activity/activity.service';
import { LocationService } from '../../data-services/location/location.data.service';
import { LogService } from '../../services/logging/log-service';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { ChangeEvent } from '../angular-virtual-list';
import { AppointmentActivity } from '../../classes/activity/appointment.activity.class';
import { UpdateMeetingPayload, MeetingDataService } from '../../data-services/meeting/meeting.data.service';
import { DiskService, OFFLINE_DB_LINKED_ENTITY_NAME } from '../../services/disk/disk.service';
import { NavigationService, PageName } from '../../services/navigation/navigation.service';
import { TrackService, TrackingEventNames } from '../../services/logging/tracking.service';
import { CallPlanOfflineService } from '../../services/call-plan/call-plan.offline.service';
import { TranslateService } from '@ngx-translate/core';
import { ContactAddress } from '../../classes/contact/contact.class';
import { IndPageTitleViewDataModel } from '@omni/models/indPageTitleDataModel';
import { DB_KEY_PREFIXES } from '@omni/config/pouch-db.config';
import { AgendaFooterService } from '../../services/footer/agenda-footer.service';
import { EventsService } from '../../services/events/events.service';
import { AuthenticationService } from '../../services/authentication.service';
import { FeatureActionsMap } from '../../classes/authentication/user.class';
import { GeolocationService } from '@omni/services/location/gelolocation';
import { isEmpty, uniqBy } from 'lodash-es';
/**
 * Generated class for the LocationComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */


@Component({
  selector: 'location',
  templateUrl: 'location.html',
  styleUrls: ['location.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})

export class LocationComponent implements OnInit {
  private firstLoad: boolean = true
  private latitude: number;
  private longitude: number;
  public tempLocationList: Array<any> = [];
  public locationSelected: any;
  public searchActivated: boolean = true;
  selectedAddressFromList: any;
  public isSearchBoxDisabled = false;
  private isInputDirty: boolean = false; // Track if input has been modified after selecting from list

  @ViewChild('search') searchInput: IonSearchbar;
  public searchTerm: string = '';
  private tempEl: HTMLInputElement;
  public locationData = []; // will be coming from service locations
  tempLocationData = [];
  indices: ChangeEvent = { start: 0, end: 0 };
  public locationData$ = new BehaviorSubject<any[]>(undefined);  // make the data into an observable stream
  scrollItems: any[];
  filteredList: any[] = [];
  participantAdded: boolean = false;
  private isLayoverPushView: boolean = false;
  public pageTitle: IndPageTitleViewDataModel;
  @Input() from: any

  public selectionFor: string = '';
  @Input() for: any;
  @Input() contactIds: any;
  @Input() accountIds: any;
  @Input() selectedAddress: any;
  @Input() callbackEvent: any;
  @Input() onDismissCallback: (isDone: boolean) => void;
  @Input() isAccountVisit: boolean;
  isGpsEnabled$ = this.geolocationService.isEnabled$;
  #ngDestroy$ = new Subject<void>();

  constructor(
    private readonly deviceService: DeviceService,
    // private mapsApiLoader: MapsAPILoader,
    private readonly uiService: UIService,
    public readonly activityService: ActivityService,
    private readonly locationService: LocationService,
    private readonly logServices: LogService,
    private readonly meetingDataService: MeetingDataService,
    private readonly disk: DiskService,
    private readonly navService: NavigationService,
    private readonly trackingService: TrackService,
    private readonly callplanService: CallPlanOfflineService,
    public readonly translate: TranslateService,
    private readonly _CD: ChangeDetectorRef,
    private readonly agendaFooterService: AgendaFooterService,
    private readonly events: EventsService,
    private readonly authService: AuthenticationService,
    private readonly addressService: AddressService,
    private readonly geolocationService: GeolocationService,
  ) {
  }

  async ngOnInit() {
    if (this.from) {
      this.isLayoverPushView = true;
    }
    if (this.for) {
      this.selectionFor = this.for;
    }
    
    //if the participants are added to the meeting do not default to the contacts location
    if (this.selectionFor && this.selectionFor == 'GENERAL_LOCATION_SELECTION') {
      let contactIds = [];
      if (this.contactIds) {
        contactIds = this.contactIds;
      }
      if (contactIds.length != 0) {
        let rawData = await this.disk.retrieve(OFFLINE_DB_LINKED_ENTITY_NAME.ADDRESSES);
        if (rawData && rawData.raw && Array.isArray(rawData.raw) && rawData.raw.length != 0) {
          rawData.raw.forEach(item => {
            if (item.hasOwnProperty('contactid') && contactIds.some(contact => contact == item['contactid'])) {
              let foundAddress: ContactAddress = {
                city: item['indskr_address.indskr_city_lu@OData.Community.Display.V1.FormattedValue'] || '',
                state: item['indskr_address.indskr_state_lu@OData.Community.Display.V1.FormattedValue'] || '',
                postal: item['indskr_address.indskr_postalcode_lu@OData.Community.Display.V1.FormattedValue'] || '',
                country: item['indskr_address.indskr_country_lu@OData.Community.Display.V1.FormattedValue'] || '',
                countryCode: item['indskr_address.indskr_countrycode_lu@OData.Community.Display.V1.FormattedValue'] || '',
                street: item['indskr_address.indskr_line1'] || '',
                street2: item['indskr_address.indskr_line2'] || '',
                street3: item['indskr_address.indskr_line3'] || '',
                region: item['indskr_address.indskr_luregion@OData.Community.Display.V1.FormattedValue'] || '',
                postOfficeBox: item['indskr_address.indskr_postofficebox@OData.Community.Display.V1.FormattedValue'] || '',
                isPrimary: item['indskr_indskr_customeraddress_v2.indskr_isprimary'] || '',
                addressId: item['indskr_indskr_customeraddress_v2.indskr_address'] || '',
                compositeAdd: item['indskr_address.indskr_composite'] || '',
                primaryContact: item['indskr_indskr_customeraddress_v2.indskr_primarycontact@OData.Community.Display.V1.FormattedValue'] || '',
                fax: item['indskr_indskr_customeraddress_v2.indskr_fax@OData.Community.Display.V1.FormattedValue'] || '',
                fax2: item['indskr_indskr_customeraddress_v2.indskr_fax2@OData.Community.Display.V1.FormattedValue'] || '',
                telephone1: item['indskr_indskr_customeraddress_v2.indskr_telephone1@OData.Community.Display.V1.FormattedValue'] || '',
                telephone2: item['indskr_indskr_customeraddress_v2.indskr_telephone2@OData.Community.Display.V1.FormattedValue'] || '',
                isSampleEligible: item['indskr_indskr_customeraddress_v2.indskr_samplingeligible'],
                customerAddressID: item['indskr_indskr_customeraddress_v2.indskr_indskr_customeraddress_v2id'] || '',
                concatanatedAddress: item['indskr_indskr_customeraddress_v2.indskr_address@OData.Community.Display.V1.FormattedValue'] || '',
                latitude: item['indskr_address.indskr_latitude'] || '',
                longitude: item['indskr_address.indskr_longitude'] || '',
              };
              if (!isEmpty(foundAddress.addressId)) {
                const idx = this.locationData.findIndex(a => a.addressId === foundAddress.addressId);
                if (idx < 0) {
                  this.locationData.push(foundAddress);
                }
              }
            }
          })
        }
      }
      if (this.accountIds) {
        let accountIds = this.accountIds;
        if (accountIds.lenght != 0) {
          // Try to retrieve from chunks first, then fall back to regular retrieve
          let rawDataArray = await this.disk.retrieveFromChunks(DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + OFFLINE_DB_LINKED_ENTITY_NAME.ADDRESSES);
          if (!rawDataArray) {
            let rawData = await this.disk.retrieve(DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + OFFLINE_DB_LINKED_ENTITY_NAME.ADDRESSES);
            if (rawData && rawData.raw) {
              rawDataArray = rawData.raw;
            }
          }
          if (rawDataArray && Array.isArray(rawDataArray) && rawDataArray.length != 0) {
            rawDataArray.forEach(item => {
              if (item.hasOwnProperty('accountid') && accountIds.some(account => account == item['accountid'])) {
                let foundAddress = {
                  compositeAdd: item['indskr_address.indskr_composite'] || '',
                  addressId: item['indskr_indskr_customeraddress_v2.indskr_indskr_customeraddress_v2id'] || '',
                };
                if (!isEmpty(foundAddress.addressId)) {
                  const idx = this.locationData.findIndex(a => a.addressId === foundAddress.addressId);
                  if (idx < 0) {
                    this.locationData.push(foundAddress);
                  }
                }
              }
            })
          }
        
        }
      }
      this.setToFullList();
      this.tempLocationData = this.locationData;
      this.participantAdded = true;
      if (this.selectedAddress) {
        this.locationSelected = this.selectedAddress.name;
        this.searchTerm = this.selectedAddress.name;
      }
    } else if (this.selectionFor && this.selectionFor == 'ACCOUNT_ADDRESSES' || (this.authService.user.buConfigs && this.authService.user.buConfigs['indskr_populateaccountaddress'])) {
      let dbKeys = ['account_linked_entityindskr_indskr_customeraddress_v2'];
      //             account_linked_entityindskr_indskr_customeraddress_v2
      dbKeys.forEach(async (dbKey) => {
        let rawData = await this.disk.retrieveFromChunks(dbKey);
        if (!rawData) {
          // Fall back to old non-chunked format
          const temp = await this.disk.retrieve(dbKey);
          if (temp) {
            rawData = temp.raw;
          }
        }
        if (rawData && Array.isArray(rawData) && rawData.length != 0) {
          rawData.forEach(item => {
            if (item.hasOwnProperty('accountid') && this.accountIds.some(account => account == item['accountid'])) {
              let foundAddress = {
                addressId: item['indskr_indskr_customeraddress_v2.indskr_address'] || '',
                compositeAdd: item['indskr_address.indskr_composite'] || '',
                customerAddressID: item['indskr_indskr_customeraddress_v2.indskr_indskr_customeraddress_v2id'] || '',
                concatanatedAddress: item['indskr_indskr_customeraddress_v2.indskr_address_Formatted'] || '',
                latitude: item['indskr_address.indskr_latitude'] || '',
                longitude: item['indskr_address.indskr_longitude'] || '',
              };

              if (!isEmpty(foundAddress.addressId)) {
                const idx = this.locationData.findIndex(a => a.addressId === foundAddress.addressId);
                if (idx < 0) {
                  this.locationData.push(foundAddress);
                }
              }
            }
          })
          this.locationSelected = (this.activityService.selectedActivity as AppointmentActivity).location;
          this.searchTerm = (this.activityService.selectedActivity as AppointmentActivity).location;
        }
      });

      this.locationData = uniqBy(this.locationData, 'compositeAdd')
      this.tempLocationData = this.locationData;

    } else if (this.activityService.selectedActivity instanceof AppointmentActivity) {
      //let tempLocation:Array<any> = [];
      let addedParticipantsData = this.activityService.selectedActivity.contacts;
      let addedAccounts = this.activityService.selectedActivity.accounts;
      //console.log("Added participant data=> " , addedParticipantsData);
      if (addedParticipantsData.length !== 0 || addedAccounts.length != 0) {

        let rawData = await this.disk.retrieve(OFFLINE_DB_LINKED_ENTITY_NAME.ADDRESSES);
        if (rawData && rawData.raw && Array.isArray(rawData.raw) && rawData.raw.length != 0) {
          rawData.raw.forEach(item => {
            if (item.hasOwnProperty('contactid') && addedParticipantsData.some(contact => contact.ID == item['contactid'])) {
              let foundAddress: ContactAddress = {
                city: item['indskr_address.indskr_city_lu@OData.Community.Display.V1.FormattedValue'] || '',
                state: item['indskr_address.indskr_state_lu@OData.Community.Display.V1.FormattedValue'] || '',
                postal: item['indskr_address.indskr_postalcode_lu@OData.Community.Display.V1.FormattedValue'] || '',
                country: item['indskr_address.indskr_country_lu@OData.Community.Display.V1.FormattedValue'] || '',
                countryCode: item['indskr_address.indskr_countrycode_lu@OData.Community.Display.V1.FormattedValue'] || '',
                street: item['indskr_address.indskr_line1'] || '',
                street2: item['indskr_address.indskr_line2'] || '',
                street3: item['indskr_address.indskr_line3'] || '',
                region: item['indskr_address.indskr_luregion@OData.Community.Display.V1.FormattedValue'] || '',
                postOfficeBox: item['indskr_address.indskr_postofficebox@OData.Community.Display.V1.FormattedValue'] || '',
                isPrimary: item['indskr_indskr_customeraddress_v2.indskr_isprimary'] || '',
                addressId: item['indskr_indskr_customeraddress_v2.indskr_address'] || '',
                compositeAdd: item['indskr_address.indskr_composite'] || '',
                primaryContact: item['indskr_indskr_customeraddress_v2.indskr_primarycontact@OData.Community.Display.V1.FormattedValue'] || '',
                fax: item['indskr_indskr_customeraddress_v2.indskr_fax@OData.Community.Display.V1.FormattedValue'] || '',
                fax2: item['indskr_indskr_customeraddress_v2.indskr_fax2@OData.Community.Display.V1.FormattedValue'] || '',
                telephone1: item['indskr_indskr_customeraddress_v2.indskr_telephone1@OData.Community.Display.V1.FormattedValue'] || '',
                telephone2: item['indskr_indskr_customeraddress_v2.indskr_telephone2@OData.Community.Display.V1.FormattedValue'] || '',
                isSampleEligible: item['indskr_indskr_customeraddress_v2.indskr_samplingeligible'],
                customerAddressID: item['indskr_indskr_customeraddress_v2.indskr_indskr_customeraddress_v2id'] || '',
                concatanatedAddress: item['indskr_indskr_customeraddress_v2.indskr_address@OData.Community.Display.V1.FormattedValue'] || '',
                latitude: item['indskr_address.indskr_latitude'] || '',
                longitude: item['indskr_address.indskr_longitude'] || '',
              };
              if (!isEmpty(foundAddress.addressId)) {
                const idx = this.locationData.findIndex(a => a.addressId === foundAddress.addressId);
                if (idx < 0) {
                  this.locationData.push(foundAddress);
                }
              }
            }
          })
        }
        // addedParticipantsData.forEach(data => {
        //   const contact = this.contactOfflineService.contacts.find(a => a.ID === data.ID);
        //   if (contact && contact.addressesList) {
        //     for (let address of contact.addressesList) {
        //       const idx = this.locationData.findIndex(a => a.addressId === address.addressId);
        //       if (idx < 0) {
        //         this.locationData.push(address);
        //       }
        //     }
        //   }
        // });
        // Try to retrieve from chunks first, then fall back to regular retrieve
        let rawAccountsDataArray = await this.disk.retrieveFromChunks(DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + OFFLINE_DB_LINKED_ENTITY_NAME.ADDRESSES);
        if (!rawAccountsDataArray) {
          let rawAccountsData = await this.disk.retrieve(DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + OFFLINE_DB_LINKED_ENTITY_NAME.ADDRESSES);
          if (rawAccountsData && rawAccountsData.raw) {
            rawAccountsDataArray = rawAccountsData.raw;
          }
        }
        if (rawAccountsDataArray && Array.isArray(rawAccountsDataArray) && rawAccountsDataArray.length != 0) {
          rawAccountsDataArray.forEach(item => {
            if (item.hasOwnProperty('accountid') && addedAccounts.some(account => account.id == item['accountid'])) {
              let foundAddress = {
                compositeAdd: item['indskr_address.indskr_composite'] || '',
                addressId: item['indskr_indskr_customeraddress_v2.indskr_address'] || '',
                customerAddressID: item['indskr_indskr_customeraddress_v2.indskr_indskr_customeraddress_v2id'] || '',
              };
              if (!isEmpty(foundAddress.addressId)) {
                const idx = this.locationData.findIndex(a => a.addressId === foundAddress.addressId);
                if (idx < 0) {
                  this.locationData.push(foundAddress);
                }
              }
            }
          })
        }
     
        this.setToFullList();
        this.locationData = uniqBy(this.locationData, 'compositeAdd')
        this.tempLocationData = this.locationData;

        console.log("Valid address for customers ", this.locationData);
        //set the template flag
        this.participantAdded = true;
      } else {
        this.locationData = this.locationService.locationData();
        this.setToFullList();
        this.logServices.logInfo(this.translate.instant('LOCATION_ENDPOINT'), this.locationData);
        this.tempLocationData = this.locationData;
      }
      if ((this.activityService.selectedActivity && this.activityService.selectedActivity.location && this.activityService.selectedActivity.location != 'No Location' && this.activityService.selectedActivity.location != this.translate.instant('NO_LOCATION'))) {
        this.locationSelected = (this.activityService.selectedActivity as AppointmentActivity).location;
        this.searchTerm = (this.activityService.selectedActivity as AppointmentActivity).location;
        this.selectedAddressFromList = this.locationData.find(item => item.compositeAdd?.toLowerCase() === this.locationSelected?.toLowerCase());
      }
    }
    await this.searchForLocation(100);
    this.initPageTitle();
    this.isSearchBoxDisabled = this.isAccountVisit;
  }

  ngOnDestroy() {
    this.#ngDestroy$.next();
    this.#ngDestroy$.complete();
  }

  private initPageTitle(): void {
    this.pageTitle = {
      id: 'location-title',
      title: this.translate.instant('LOCATION_CHOOSE_LOCATION'),
      controls: [{
        id: "close",
        imgSrc: 'assets/imgs/header_cancel.svg',
        name: this.translate.instant('CANCEL'),
        isDisabled: false,
        align: "right"
      },
      {
        id: "done",
        imgSrc: 'assets/imgs/header_complete.svg',
        name: this.translate.instant('DONE'),
        isDisabled: this.isDoneButtonDisabled,
        align: "right"
      }],
    };
  }

  public onPageTitleControlClick(id: string) {
    switch (id) {
      case 'close':
        this.onCancelModal();
        break;
      case 'done':
        this.onCloseModal();
        break;
      default:
        console.log("Unhandled switch case statement");
        break;
    }
  }

  public get isDoneButtonDisabled(): boolean {
    let flag: boolean = false;
    if (this.selectionFor && this.selectionFor == 'GENERAL_LOCATION_SELECTION') {
      if ((this.tempEl && this.selectedAddress?.name == this.tempEl.value)
        || (!this.tempEl || !this.tempEl.value || this.tempEl.value.trim() == "")
      ) {
        flag = true;
      }
    } else if ((this.selectionFor === 'ACCOUNT_ADDRESSES') || (this.authService.user.buConfigs && this.authService.user.buConfigs['indskr_populateaccountaddress'])) {
      flag = !this.locationData.find((item) => item.compositeAdd === this.locationSelected);
    } else if ((this.tempEl && this.activityService.selectedActivity && this.activityService.selectedActivity.location == this.tempEl.value) || ((this.activityService.selectedActivity.location == undefined || this.activityService.selectedActivity.location == 'No Location' || this.activityService.selectedActivity.location == this.translate.instant('NO_LOCATION')) && (!this.tempEl || !this.tempEl.value || this.tempEl.value == ""))) {
      flag = true;
    }
    return flag;
  }

  private initSuggestedLocationsBySelectedAccountsContacts() {

  }

  ionViewWillLeave() {
    //this.map.setDiv(undefined);
    this.locationData = this.locationService.locationData(); //cache mechanism
  }

  ionViewDidEnter() {
    if (!this.firstLoad) {
      //this.map.setDiv('ionic-map-canvas');
      this.firstLoad = true;
    } else {
      this.firstLoad = false;
    }
  }
  #debounceSearchTimeout: NodeJS.Timeout;
  /**
   * Search For location by first traversing through the local cached data , if the location is not there we trigger the Google Maps API for places
   *
   * @memberof LocationComponent
   */
  private async searchForLocation(debounce: number = 500) {
    await new Promise(resolve => {
      if (this.#debounceSearchTimeout) {
        clearTimeout(this.#debounceSearchTimeout);
      }
      this.#debounceSearchTimeout = setTimeout(resolve, debounce);
    });
    if (this.selectionFor === 'ACCOUNT_ADDRESSES' || (this.authService.user.buConfigs && this.authService.user.buConfigs['indskr_populateaccountaddress'])) {
      this.searchAddressList();
      return;
    }

    if (this.searchTerm && this.searchTerm.length > 200) {
      this.searchTerm = this.searchTerm.substr(0, 200);
      this.logServices.logInfo(this.translate.instant('LOCATION_SEARCH_TERM'), this.searchTerm.length);
      return;
    } else if (this.searchTerm.length == 0) {
      this.searchActivated = false;
      this.tempLocationList = [];
      this.initPageTitle();
    } else {
      this.searchActivated = true;
      this.locationData = this.tempLocationData; //reset the data back to its original form
      // this.locationData = this.filterCachedLocation(this.searchTerm);
      this.tempLocationList = this.locationData; // make a new list for the search items
      this.initPageTitle();
    }

    //this.tempLocationList = [];//reset
  }

  async onSearchInputChange(event: any) {
    this.tempEl = await this.searchInput.getInputElement();
    this.tempEl.value = this.searchTerm = event.detail.value;
    await this.searchForLocation(100);
    this.selectedAddressFromList = null;
    this.latitude = null;
    this.longitude = null;
    this.isInputDirty = true; // Mark as dirty when user types/changes input
  }



  private searchAddressList() {
    if (this.searchTerm === '' || this.searchTerm === 'No Location') {
      this.locationData = this.tempLocationData;
      this.locationSelected = '';
      this.searchActivated = true;
      this.initPageTitle();
      return;
    }

    this.locationData = this.tempLocationData; //reset the data back to its original form
    this.searchActivated = true;
    this.initPageTitle();
  }

  async selectAddressFromList(addressObj) {
    this.tempEl = await this.searchInput.getInputElement();
    this.searchTerm = addressObj.compositeAdd;
    this.selectedAddressFromList = addressObj;
    this.locationSelected = addressObj.compositeAdd;
    this.latitude = addressObj.latitude;
    this.longitude = addressObj.longitude;
    this.searchActivated = false;
    this.isInputDirty = false; // Mark as not dirty when address is selected from list
    await this.searchForLocation(100);
    this.initPageTitle();
  }
  /**
   * Sets the location value in the search bar
   *
   * @param {*} eventData
   * @memberof LocationComponent
   */
  onLocationClick(eventData: any): void {
    this.selectAddressFromList(eventData?.compositeAdd ? eventData : { compositeAdd: eventData });
  }

  isSelectedAddress(address: string): boolean {
    return this.locationData.some(item => item.compositeAdd?.toLowerCase() === address?.toLowerCase());
  }

  /**
   * Get the current location by pressing a button , i use a lot of callbacks in this routine , downsides of javascript/typescript
   *
   * @memberof LocationComponent
   */
  async getCurrentLocation() {
    const position = await this.geolocationService.getCurrentPositionName()
    this.latitude = position.latitude;
    this.longitude = position.longitude;
    this.tempEl = await this.searchInput.getInputElement();
    this.tempEl.value = position.address;
    this.searchTerm = this.locationSelected = position.address;
    this.isInputDirty = false;
    this.selectedAddressFromList = null; // Clear selected address since user used current location
    this.initPageTitle();
    this._CD.markForCheck();
  }
  /**
   * routines to convert back to actual adressses if no location is given , sent that data back to the activity detail page
   *
   * @memberof LocationComponent
   */
  private onCloseModal() {
    if (this.selectionFor == 'GENERAL_LOCATION_SELECTION') {
      this._doGeneralSelection(true);
      return;
    }


    if (this.selectionFor === 'ACCOUNT_ADDRESSES' || (this.authService.user.buConfigs && this.authService.user.buConfigs['indskr_populateaccountaddress'])) {
      this._doGeneralSelection(true);
      return;
    }


    if (this.activityService.selectedActivity instanceof AppointmentActivity) {
      this.trackingService.tracking('MeetingLocationUpdate', TrackingEventNames.ACTIVITY)
      let currentAppointmentActivity: AppointmentActivity = this.activityService.selectedActivity;

      let payload = new UpdateMeetingPayload(
        currentAppointmentActivity.subject,
        currentAppointmentActivity.location,
        currentAppointmentActivity.scheduledStart,
        currentAppointmentActivity.scheduledEnd,
        currentAppointmentActivity.notes
      );

      payload.location = this.searchTerm;
      this.activityService.updateSelectedActivityProps({ location: this.searchTerm });
      this.activityService.getActivityByID(this.activityService.selectedActivity.ID).location = this.searchTerm;

      // Set latitude/longitude from selected address if available
      let latitude: number = null;
      let longitude: number = null;

      // If input is not dirty and address was selected from list, use its lat/long
      if (!this.isInputDirty && this.latitude && this.longitude) {
        latitude = this.latitude;
        longitude = this.longitude;
      }

      // Set lat/long on meeting and payload
      currentAppointmentActivity.indskr_meetinglocationlatitude = latitude;
      currentAppointmentActivity.indskr_meetinglocationlongitude = longitude;
      const activityInList = this.activityService.getActivityByID(this.activityService.selectedActivity.ID);
      if (activityInList instanceof AppointmentActivity) {
        activityInList.indskr_meetinglocationlatitude = latitude;
        activityInList.indskr_meetinglocationlongitude = longitude;
      }
      payload.indskr_meetinglocationlatitude = latitude ?? null;
      payload.indskr_meetinglocationlongitude = longitude ?? null;

      if (this.deviceService.isOffline || this.activityService.hasOfflineMeetingData(currentAppointmentActivity.ID)) {
        this.activityService.upsertMeetingsOfflineData(currentAppointmentActivity);
      } else {
        this.meetingDataService.updateMeeting(this.activityService.selectedActivity, payload, false, this.navService.getCurrentPageName() === PageName.GoAppActivitiesPageComponent)
          .catch(error => {
            console.error('onCloseModal: ', error);
            this.activityService.upsertMeetingsOfflineData(currentAppointmentActivity, false, true);
          });
      }
      this.events.publish('aciviiyCreatedRefreshTODO', this.activityService.selectedActivity)

   

    }
    this.uiService.showNewActivity = false;
 
    if (this.isLayoverPushView) {
      this.navService.popChildNavPageWithPageTracking().then(() => {
        this.onDismissCallback?.(true);
      });
    } else if (this.deviceService.isMobileDevice && this.navService.getCurrentPageName() == PageName.LocationComponent) {
      this.navService.popWithPageTracking();
    } else {
      if (this.navService.getCurrentPageName() == PageName.GoAppActivitiesPageComponent) {
        this.uiService.activeView = 'Appointment';
      }
      if (this.navService.getCurrentPageName() == PageName.ContactPageComponent) {
        this.uiService.activeView = 'activityTimelineDetails';
      }
      if (this.navService.getCurrentPageName() == PageName.CallPlanComponent) {
        this.callplanService.callPlanPageView = 'CallPlanNewMeetingDetails';
        this.navService.popChildNavPageWithPageTracking();
      }
    }
  }
  private onCancelModal() {
    if (this.selectionFor == 'GENERAL_LOCATION_SELECTION') {
      this._doGeneralSelection(false);
      return;
    }
    this.uiService.showNewActivity = false;
   
    if (this.isLayoverPushView) {
      this.navService.popChildNavPageWithPageTracking().then(() => {
        this.onDismissCallback?.(false);
      });
    } else if (this.deviceService.isMobileDevice && this.navService.getCurrentPageName() == PageName.LocationComponent) {
      this.navService.popWithPageTracking();
    } else {
      if (this.navService.getCurrentPageName() == PageName.GoAppActivitiesPageComponent) {
        this.uiService.activeView = 'Appointment';
      }
      if (this.navService.getCurrentPageName() == PageName.ContactPageComponent) {
        this.uiService.activeView = 'activityTimelineDetails';
      }
      if (this.navService.getCurrentPageName() == PageName.CallPlanComponent) {
        this.callplanService.callPlanPageView = 'CallPlanNewMeetingDetails';
        this.navService.popChildNavPageWithPageTracking();
      }
    }
  }

  private _doGeneralSelection(isDone) {
    this.navService.popChildNavPageWithPageTracking().then(() => {
      if (isDone && this.callbackEvent && this.tempEl.value != "") {
        let selectedLocation = this.selectionFor === 'ACCOUNT_ADDRESSES' ? this.selectedAddressFromList : this.tempEl.value;
        this.callbackEvent(selectedLocation);
      } else if (this.selectionFor === 'ACCOUNT_ADDRESSES' || (this.authService.user.buConfigs && this.authService.user.buConfigs['indskr_populateaccountaddress'])) {
        this.callbackEvent(null)
      }
      if (this.onDismissCallback) {
        this.onDismissCallback(isDone);
      }
    });
  }

  /**
   *
   *
   * @private
   * @memberof LocationComponent
   */
  private setToFullList(): void {
    this.locationData = uniqBy(this.locationData, 'compositeAdd');
    this.addressService.markFavouriteAddress(this.locationData);
    this.filteredList = this.locationData
      .slice()
      .map((item, idx) => {
        item.order = idx;
        return item;
      });

    this.locationData$.next(this.filteredList);
    //console.log(this.locationData$);
  }
  // tslint:disable-next-line:max-file-line-count

  refreshPlanToDO() {
    if (this.agendaFooterService.actSegment === 'agenda' && this.agendaFooterService.planTabSegment === 'planTabTodo') {
      this.events.publish('aciviiyCreatedRefreshTODO', this.activityService.selectedActivity);
    }
  }

  shouldShowSection() {
    if (this.selectionFor !== 'GENERAL_LOCATION_SELECTION') {
      return true;
    } else {
      return this.participantAdded && (!this.searchActivated && this.locationData$.getValue().length != 0 || this.searchActivated && this.tempLocationList.length != 0)
    }
  }

  shouldShowNoLocationData() {
    if (this.selectionFor !== 'GENERAL_LOCATION_SELECTION') {
      return false;
    } else {
      return !this.participantAdded || (!this.searchActivated && this.locationData$.getValue().length == 0 || this.searchActivated && this.tempLocationList.length == 0)
    }
  }

  hasMeetingURL() {
    return (this.authService.hasFeatureAction(FeatureActionsMap.REMOTE_FEATURE) || this.authService.hasFeatureAction(FeatureActionsMap.TEAMS_MEETING)) && this.from != 'EventsToolPage' && (!isEmpty(this.activityService.selectedActivity.meetingURL) && this.selectionFor !== 'ACCOUNT_ADDRESSES' || !isEmpty(this.activityService.selectedActivity['indskr_teamslink']));
  }

  meetingURL() {
    if (!isEmpty(this.activityService.selectedActivity['indskr_teamslink'])) {
      return this.activityService.selectedActivity['indskr_teamslink'];
    } else if (!isEmpty(this.activityService.selectedActivity.meetingURL))
      return this.activityService.selectedActivity.meetingURL
  }

  public favourite() {

  }

  showCurrentLocationButton() {
    return (this.authService.user.buConfigs
      && !this.authService.user.buConfigs['indskr_populateaccountaddress']
      && this.selectionFor !== 'ACCOUNT_ADDRESSES'
    )
  }

  trackById(index: number, item: any) { return item?.id || item?.ID || index; }
}
